// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2572w","name":"ConsentHeader_name__2q3EU","birthday":"ConsentHeader_birthday__al6hM","skeleton":"ConsentHeader_skeleton__14Sb6"};